<div class="counter-container">
  {{ maxValue && _value > maxValue ? maxValue + '+' : _value }}
</div>
